import './Thesis.css';

export default function Thesis() {
  return (
    <>
      <section className="page-header">
        <div className="page-label">Our Thesis</div>
        <h1 className="page-title">We build what the industry is missing.</h1>
      </section>

      <section className="thesis-body">
        <aside className="thesis-sidebar">
          <div className="sidebar-label">On This Page</div>
          <nav className="sidebar-nav">
            <a href="#belief">Core Belief</a>
            <a href="#model">Our Model</a>
            <a href="#principles">Principles</a>
            <a href="#verticals">Verticals</a>
          </nav>
        </aside>

        <div className="thesis-main">
          <div className="thesis-section" id="belief">
            <div className="t-heading">Core Belief</div>
            <p className="t-body">Most software for the entertainment industry is built by outsiders — teams who studied a market from a distance and guessed at its problems. The products that win are built by people who live the problem: operators native to the industry, building for themselves first.</p>
            <p className="t-body">Lakeshore exists to build those companies. We are a Los Angeles–based product studio — a product factory, not an idea factory. We operate real businesses in music and media, turn the problems we hit every day into AI-native products, and ship them.</p>
          </div>

          <div className="thesis-section" id="model">
            <div className="t-heading">Our Model</div>
            <p className="t-body">We operate at the intersection of domain expertise and AI — ideating, designing, and shipping products for the industries we work in every day.</p>
            <p className="t-body">Our process has three layers: <strong>Operate</strong> — we run real businesses in music and media, so real problems surface daily. <strong>Build</strong> — we design and engineer AI-native products in-house, fast. <strong>Ship</strong> — products go live, get used, and compound. Each build makes the next one faster.</p>
          </div>

          <div className="thesis-section" id="principles">
            <div className="t-heading">Principles</div>
            <div className="principles-grid">
              <div className="principle-card">
                <div className="pr-num">01</div>
                <div className="pr-title">Operator-Led</div>
                <div className="pr-desc">Every product starts as a problem we personally hit running companies. We build for ourselves first.</div>
              </div>
              <div className="principle-card">
                <div className="pr-num">02</div>
                <div className="pr-title">Product Factory</div>
                <div className="pr-desc">Ideas are the input — shipped, working products are the output. We build first and talk after.</div>
              </div>
              <div className="principle-card">
                <div className="pr-num">03</div>
                <div className="pr-title">Vertical Conviction</div>
                <div className="pr-desc">We go deep, not wide — music, media, education, legal, culture. Markets we operate in, not markets we studied.</div>
              </div>
            </div>
          </div>

          <div className="thesis-section" id="verticals">
            <div className="t-heading">Verticals</div>
            <p className="t-body">We focus on industries we know from the inside — markets with real demand, slow incumbents, and workflows AI can transform overnight.</p>
            <div className="verticals-grid">
              <div className="principle-card">
                <div className="pr-num">Education</div>
                <div className="pr-desc">Authoritative books transformed into interactive AI learning.</div>
              </div>
              <div className="principle-card">
                <div className="pr-num">Music</div>
                <div className="pr-desc">Artist-side tools for catalogs, contracts, and operations.</div>
              </div>
              <div className="principle-card">
                <div className="pr-num">Live</div>
                <div className="pr-desc">Touring infrastructure for artists, managers, and production teams.</div>
              </div>
              <div className="principle-card">
                <div className="pr-num">Legal</div>
                <div className="pr-desc">AI legal intelligence for independent artists and labels.</div>
              </div>
              <div className="principle-card">
                <div className="pr-num">Culture</div>
                <div className="pr-desc">Media and television for underserved audiences.</div>
              </div>
              <div className="principle-card">
                <div className="pr-num">AI</div>
                <div className="pr-desc">AI-native products embedded into real industry workflows.</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
